"use strict";
// @ts-ignore
try {
    self['workbox:range-requests:7.4.0'] && _();
}
catch (e) { }
